import React, { useState } from 'react';
import kevinBarnesImg from './Kevin_barnes_signal.jpg';


const stories = [
  {
    id: 1,
    headline: "OF MONTREAL @ WEBSTER HALL — JUNE 23",
    body: "This will be the 7th time I see this band. Athens, Georgia indie legends of Montreal bring their theatrical live show to Webster Hall on June 23rd. Core pillars of the Elephant Six Collective alongside Neutral Milk Hotel, Kevin Barnes and crew remain one of the most unpredictable and essential live acts in indie pop.",
    time: "upcoming",
    image: kevinBarnesImg,
  },
  {
    id: 2,
    headline: "SIGNALBLEED.NYC IS BORN",
    body: "A pre-launch look at NYC's new underground music discovery platform for artists, venues, and local listeners.",
    time: "just now",
    image: null,
  },
  {
    id: 3,
    headline: "SUBMIT YOUR GIG",
    body: "Any show, any venue, any borough. We'll post it and bump small shows to the top of the list.",
    time: "1h ago",
    image: null,
  },
];


const MusicNewsPanel = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const handlePrev = () => {
    setActiveIndex(prev => (prev - 1 + stories.length) % stories.length);
  };

  const handleNext = () => {
    setActiveIndex(prev => (prev + 1) % stories.length);
  };

  const story = stories[activeIndex];

  return (
    <div className="music-news-panel">
      <div className="music-news-header">
        <span className="music-news-title">NYC MUSIC NEWS ⚡</span>
        <span className="music-news-viewall">VIEW ALL NEWS →</span>
      </div>

      <div className="music-news-body">
        <button className="news-arrow news-arrow-left" onClick={handlePrev}>‹</button>

        <div className="music-news-card">
	  <div className="music-news-image">
  {story.image ? (
    <img
      src={story.image}
      alt={story.headline}
      style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "4px" }}
    />
  ) : (
    <>SIGNAL<br />BLEED</>
  )}
</div>
          <div className="music-news-copy">
            <h3>{story.headline}</h3>
            <p>{story.body}</p>
            <span className="news-time">{story.time}</span>
          </div>
        </div>

        <button className="news-arrow news-arrow-right" onClick={handleNext}>›</button>
      </div>

      <div className="news-dots">
        {stories.map((_, i) => (
          <span
            key={i}
            className={`news-dot ${i === activeIndex ? 'active' : ''}`}
            onClick={() => setActiveIndex(i)}
          />
        ))}
      </div>
    </div>
  );
};

export default MusicNewsPanel;
